import React, {Component} from "react";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import Alert from "react-s-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import {isValidLuca} from "../../../common/componentValidation";

class LucaConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            error: {}
        }
    }

    componentDidMount() {
        this.fetch();
    }

    fetch = () => {
        let self = this;
        let customer = self.props.customer;
        let params = {
            url: `/luca/fetchLucaInfo?customerId=${customer.recordId}`,
            method: "get"
        };
        request(params)
            .then(function (response) {
                if (response.data) {
                    self.setState({data: response.data});
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    save = () => {
        let self = this;
        let data = deepCopyObject(self.state.data);
        let result = isValidLuca(data);
        if(result.valid){
            let params = {
                url: "/luca/saveLucaInfo",
                method: "post",
                data: data
            };
            request(params)
                .then(function (response) {
                    if (response.data) {
                        Alert.success("Kayetme işlemi başarılı.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({data: response.data});
                    }
                }).catch(function (error) {
                showAxiosError(error);
            });
        }else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    delete = () => {
        let self = this;
        let params = {
            url: "/luca/deleteLucaInfo",
            method: "post",
            data: self.state.data
        };
        request(params)
            .then(function (response) {
                Alert.success("silme işlemi başarılı şekilde gerçekleşti.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({data: {}});
            }).catch(function (error) {
            Alert.error("Silme işlemi gerçekleşmedi!!!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            showAxiosError(error);
        });
        self.setState({alert: null});
    }

    onChangeData = (name, value) => {
        let data = deepCopyObject(this.state.data);
        data[name] = value;
        this.setState({data: data});
    }

    render() {
        return (
            <Row className="FormRenk"
                 style={{marginLeft: '0px', paddingLeft: '0px', marginRight: "0px", paddingTop: '30px'}}>
                <Col sm={12} className="row">
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>NetteCap Kullanıcı Adı</Label>
                            <Col sm={8}>
                                <Input type="text"
                                       id="nettecapUser"
                                       className="form-control"
                                       style={{border: '0.1em solid #000'}}
                                       placeholder="NetteCap Kullanıcı Adı"
                                       value={this.state.data && this.state.data.nettecapUser ? this.state.data.nettecapUser : ''}
                                       onChange={(e) => this.onChangeData("nettecapUser", e.target.value)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>NetteCap Şifresi</Label>
                            <Col sm={8}>
                                <Input type="password"
                                       id="nettecapPwd"
                                       className="form-control"
                                       style={{border: '0.1em solid #000'}}
                                       placeholder="NetteCap Şifresi "
                                       value={this.state.data && this.state.data.nettecapPwd ? this.state.data.nettecapPwd : ''}
                                       onChange={(e) => this.onChangeData("nettecapPwd", e.target.value)}
                                       />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>İşNet Müşteri Numarası</Label>
                            <Col sm={8}>
                                <Input type="text"
                                       id="nettecapMhn"
                                       style={{border: '0.1em solid #000'}}
                                       className="form-control"
                                       placeholder={"İşNet Müşteri Numarası"}
                                       value={this.state.data && this.state.data.nettecapMhn ? this.state.data.nettecapMhn : ''}
                                       onChange={(e) => this.onChangeData("nettecapMhn", e.target.value)}
                                       />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>Luca Üyelik Numarası</Label>
                            <Col sm={8}>
                                <Input type="text"
                                       id="lucaNumber"
                                       style={{border: '0.1em solid #000'}}
                                       className="form-control"
                                       placeholder={"Luca Üyelik Numarası"}
                                       value={this.state.data && this.state.data.lucaNumber ? this.state.data.lucaNumber : ''}
                                       onChange={(e) => this.onChangeData("lucaNumber", e.target.value)}
                                       />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup row>
                            <Label sm={4}>Nettecap Üyelik Numarası</Label>
                            <Col sm={8} >
                                <Input type="text"
                                       id="netteCapNumber"
                                       style={{border: '0.1em solid #000'}}
                                       className="form-control"
                                       placeholder={"Nettecap Üyelik Numarası"}
                                       value={this.state.data && this.state.data.netteCapNumber ? this.state.data.netteCapNumber : ''}
                                       onChange={(e) => this.onChangeData("netteCapNumber", e.target.value)}
                                       />
                            </Col>
                        </FormGroup>
                    </Col>
                </Col>
                <Col sm="6">
                    <FormGroup row className="col-sm-12">
                        <Button className="TekBtn kaydet pull-right"
                                style={{marginRight: "10%"}}
                                onClick={() => this.save()}>
                            Kaydet
                        </Button>
                        <Button className="TekBtn delete bHizala mr-5"
                                disabled={this.state.data && !this.state.data.recordId}
                                onClick={e => {
                                    this.setState({
                                        alert: (
                                            <SweetAlert showCancel warning
                                                        confirmBtnText="Evet"
                                                        cancelBtnText="Hayır"
                                                        confirmBtnBsStyle="danger"
                                                        cancelBtnBsStyle="default"
                                                        title={"Luca bilgilerinizi silmek istediğize emin misiniz?"}
                                                        onConfirm={() => {
                                                            this.delete()
                                                        }}
                                                        onCancel={() => this.setState({alert: null})}>
                                                {"Luca bilgileri silinecek devam edilsin mi?"}
                                            </SweetAlert>)
                                    })
                                }}>
                            Sil
                        </Button>
                    </FormGroup>
                </Col>
                {this.state.alert &&
                    <div className="row satirBasi">
                        {this.state.alert}
                    </div>
                }
            </Row>
        );
    }

}

export default LucaConfig;
